import { Action } from '@ngrx/store';

export const DISABLE_ACCOUNT_SUCCESS = '[Customer] User Disable Account Success';

export class DisableAccountSuccessAction implements Action {
  readonly type = DISABLE_ACCOUNT_SUCCESS;

  constructor(public payload: { user: { key: string, identifier: string }, status: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/DisableAccountSuccessAction.ts